import QdContainer from "components/Common/QdContainer"
import React from "react"

import Header from "./Header"
import LlmInstructionsPanel from "./Panel"

/** Standalone route (/crs/llm-instructions). The same panel is also reachable as a card under
 *  Admin > System Configuration > Email Appointment Management, which supplies its own
 *  container and header -- see pages/SystemConfigurationV2. */
function LlmInstructions() {
  return (
    <QdContainer>
      <Header />
      <div className="mt-3">
        <LlmInstructionsPanel />
      </div>
    </QdContainer>
  )
}

export default LlmInstructions
